// This icon file is generated automatically.
var PStepForwardOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M8.57 6.26l-5.99 4.7a.34.34 0 01-.55-.26V1.3c0-.29.33-.44.55-.27l5.99 4.7c.17.14.17.4 0 .53m.27 5.24h1c.07 0 .13-.06.13-.13V.63A.12.12 0 009.84.5h-1a.12.12 0 00-.12.13v10.74c0 .07.05.13.12.13", "fill-rule": "nonzero" } }] }, "name": "p-step-forward", "theme": "outlined" };
export default PStepForwardOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PStepForwardOutlined.js
// module id = 3654
// module chunks = 0